import { render } from "./v-status.vue?vue&type=template&id=b9dd47e8"
import script from "./v-status.vue?vue&type=script&lang=js"
export * from "./v-status.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__